import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class MeasurementAndTraceability extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'measurementAndTraceability'}
            title={ t('support.procedure.P3.title') }
            exportTitle={ t('support.procedure.P3.exportTitle') }
            exportFileName={'measurementAndTraceability.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (MeasurementAndTraceability);